import React, { useState } from 'react';
import { Typography, Card, IconButton, Box, Grid, useTheme } from '@mui/material';
import RoomIcon from "@mui/icons-material/Room";
import eventFixedFieldsLabel from './eventFieldsConstants';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';
import moment from 'moment';
import AlertDialog from '../AlertDialog/AlertDialog';
import DescriptionComponent from './DescriptionComponent';
import { Role } from '../../helper';
import { userService } from '../../services';

const EventList = (props) => {
    const [showAlert, setShowAlert] = useState({
        show: false,
        id: null
    });

    const { events, onEdit, onDelete } = props;
    const userRole = userService.getUserRole();
    const theme = useTheme();
    const renderDescription = (value) => {
        const descriptionHTMLTemplate = `<html>
                <head>
                    <style>
                        table {
                            width: 100% !important;
                            border-collapse: collapse;
                        }
                        th, td {
                            border-collapse: collapse;
                            padding: 8px;
                        }
                        a {
                            color: #1D428A;
                            text-decoration-line: none;
                        }
                    </style>
                </head>
                <body>
                    ${value}
                </body>
            </html>`;

        return <div dangerouslySetInnerHTML={{
            __html: descriptionHTMLTemplate.replace(
                /<img /g,
                '<img style="max-width:100%;" '
            )
        }} style={{
            fontFamily: 'Arial !important',
        }}></div>;
    };

    const onDeleteEvent = () => {
        onDelete(showAlert.id);
        setShowAlert({
            show: false,
            id: null,
        });
    };

    const formatData = (data, format) => {

        if (data && format === 'filterInList') {
            return props?.eventTypes?.find(item => item.Id === data)?.Text;
        } else if (data && format === 'hh:mm A') {
            return moment(data, "HH:mm:ss").format(format);
        } else if (data && format) {
            return moment(data).format(format);
        } else if (!data) {
            return "";
        } else {
            return data;
        }
    };

    const LocationIcon = () => <RoomIcon />;

    return (
        <Box style={{ flex: 1, flexDirection: 'column', marginTop: 20 }}>
            {events?.map((event, index) => (
                <Card key={index} style={{
                    marginBottom: '20px', padding: '10px', border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.051)" : "#e8e8e8"}`,
                    boxShadow: `0px 3px 5px 2px ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.051)" : "rgba(0, 0, 0, 0.1)"}`,
                }}>
                    <Box style={{
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: event.Color,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '10px',
                        margin: "-10px",
                        marginBottom: '10px',
                        color: '#000000'
                    }}>
                        <Box style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                            {/* <NBAFamilyLogo /> */}
                            <Typography variant="subtitle1">
                                {`${event.Title}`}
                            </Typography>
                        </Box>
                        <Box style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}>
                            {event.Location ? (
                                <>
                                    <Typography variant="body2" style={{ marginRight: '5px', marginLeft: 30 }}>
                                        {event.Location}
                                    </Typography>
                                    <LocationIcon />
                                </>
                            ) : null}
                            {(userRole === Role.Admin) ? <>
                                <IconButton onClick={() => onEdit(event)}>
                                    <EditOutlined style={{ color: '#000000' }} />
                                </IconButton>
                                <IconButton onClick={() => setShowAlert({ show: true, id: event.Id })}>
                                    <DeleteOutlined style={{ color: '#000000' }} />
                                </IconButton>
                            </> : null}
                        </Box>
                    </Box>

                    <Box style={{ marginTop: '10px' }}>
                        <Grid container spacing={1}>
                            {Object.keys(event).map(key => {
                                if (eventFixedFieldsLabel && eventFixedFieldsLabel[key]) {
                                    return (
                                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={key}>
                                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                <Typography variant="body2" style={{ marginRight: 5, fontWeight: 500 }}>
                                                    {`${eventFixedFieldsLabel[key]?.name} : `}
                                                </Typography>
                                                <Typography variant="body2" style={{ fontSize: 13 }}>
                                                    {`${formatData(event[key], eventFixedFieldsLabel[key]?.format)}`}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    );
                                }
                                return null;
                            })}
                        </Grid>
                        {event.Description ? (
                            <>
                                <Typography variant="body2" style={{ fontWeight: 500, marginTop: 10 }}>
                                    Description :
                                </Typography>
                                <DescriptionComponent child={renderDescription(event.Description)} height={100} />
                            </>
                        ) : null}
                    </Box>
                </Card>
            ))}
            <AlertDialog
                title={`Delete Event`}
                description={`Are you sure you want to delete this event?`}
                buttonTitle={'Delete'}
                showAlert={showAlert.show}
                onButtonAction={() => onDeleteEvent()}
                addCancel={true}
                onClose={() => setShowAlert({
                    show: false,
                    id: null
                })}
            />
        </Box>
    );
};

export default EventList;